import { render, staticRenderFns } from "./HIPAAAgreementModal.vue?vue&type=template&id=6a5021c9&scoped=true&"
import script from "./HIPAAAgreementModal.vue?vue&type=script&lang=ts&"
export * from "./HIPAAAgreementModal.vue?vue&type=script&lang=ts&"
import style0 from "./HIPAAAgreementModal.vue?vue&type=style&index=0&id=6a5021c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5021c9",
  null
  
)

export default component.exports